import React, {useEffect, useState} from "react"

import { Row, Col, Card, CardBody, Form, Label, CardImg } from "reactstrap"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import "../PublicPromoCode/datatables.scss"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import _ from 'lodash'
import Select from "react-select"
import {Link} from 'react-router-dom'
import SweetAlert from "react-bootstrap-sweetalert"
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const EditCheckout = (props) => {
    
    const statusOptions = [
      {value: "Y", label: "Enabled"},
      {value: "N", label: "Disabled"}
    ]
   
    const [token, setToken] = useState()
    const [pageName, setPageName] = useState('TopRibbon')
    const [selectedStatus, setselectedStatus] = useState(statusOptions[0])
    const [success_msg, setsuccess_msg] = useState(false)
    const [success_msgText, setsuccess_msgText] = useState(false)
    const [errorMessage, SetErrorMessage] = useState('')
    const [errorMsgAlert, setErrorMsgAlert] = useState(false)
    const [breadCrumbText, setBreadcrumbText] = useState('')
    const [ItemData, setItemData] = useState({})
    const [msgText, setMsgText] = useState("Top Ribbon")
    const [redirectPath, setRedirectPath] = useState("/estore-home/top-ribbons")
    const [Deeplink, setDeeplink] = useState({})

    useEffect(()=>{
        const token = localStorage.getItem("AuthenticationToken")
        setToken(token)
        console.log("Props checking", props?.location?.state)
        
            setPageName("eStore_checkout_text")
            setMsgText("eStore checkout text")
            setRedirectPath("/estore-home/checkout")
            setBreadcrumbText("Edit Estore Checkout Text")
            setItemData(props?.location?.state?.item)
        
    }, [])

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success" 
        onConfirm={() => {
          setsuccess_msg(false)       
          props?.history.push(redirectPath)
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {success_msgText ? success_msgText : "Top ribbon Added."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = (msg) => {
    return (
      <SweetAlert
        title="Warning!"
        warning        
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
        }}
      >
        {msg ? msg : (errorMessage ? errorMessage : "Error. Something went wrong.")}
      </SweetAlert>
    )
  }
  
  function handleSubmit(){
    
    const version = document.getElementById("version_input").value;
    const status = selectedStatus ? selectedStatus.value : ""
    const name = document?.getElementById("name_input")?.value ? document?.getElementById("name_input")?.value : ""
    const detail = document?.getElementById("description_input")?.value ? document?.getElementById("description_input")?.value : ""
    
    if(name == ""){
      SetErrorMessage("Please enter name")
      setErrorMsgAlert(true)
      return
    }
    if(detail == ""){
        SetErrorMessage("Please enter detail")
        setErrorMsgAlert(true)
        return
    }

    let deeplink = {
        name: name,
        detail: detail
    }

    console.log("Checking Data", deeplink, status, version)

    var myHeaders = new Headers();
    
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("path", "settings/add");
    formdata.append("item_name", pageName);
    formdata.append("item_detail", JSON.stringify(deeplink));
    formdata.append("item_status", status);
    formdata.append("item_version", version);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      mimeType: "multipart/form-data"
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log("Checking result", result)
        if(result){
          if(result?.Items?.length > 0){
            setsuccess_msg(true)
            setsuccess_msgText(`${msgText} added successfully`)
          }
        }else{
          SetErrorMessage(`Unable to add ${msgText?.toLowerCase()}`)
          setErrorMsgAlert(true)
        }
      })
      .catch(error => console.log('error', error)); 
  }

  
  /**
   * Formats the size
   */
    function handleEdit(){

        const version = document.getElementById("version_input").value ? document.getElementById("version_input").value : ItemData?.item_version;
        const status = selectedStatus ? selectedStatus.value : ItemData?.item_status
        const name = document?.getElementById("name_input")?.value ? document?.getElementById("name_input")?.value : ""
        const detail = document?.getElementById("description_input")?.value ? document?.getElementById("description_input")?.value : ""
        
        if(name == ""){
            SetErrorMessage("Please enter name")
            setErrorMsgAlert(true)
            return
          }
          if(detail == ""){
              SetErrorMessage("Please enter detail")
              setErrorMsgAlert(true)
              return
          }
      
        console.log("Checking Edit  data", version, status)
        var myHeaders = new Headers();
        
        myHeaders.append("Authorization", "Bearer " + token);
        myHeaders.append("cache-control", "no-cache");
        
        myHeaders.append("Cookie", "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208");

        var formdata = new FormData();
        formdata.append("path", "settings/update");
        formdata.append("item_status", status);
        formdata.append("item_version", version);
        formdata.append("item_detail", detail);
        formdata.append("item_name", pageName);
        formdata.append("item_id", ItemData?.item_id);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          mimeType: "multipart/form-data",
        };
        fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
          .then(response => {              
              console.log("Settings data updating", response)
              if(response.status == 200){
                setsuccess_msgText(`${msgText} updated successfully`)
                setsuccess_msg(true)
              }else{
                SetErrorMessage(`Unable to update ${msgText}`)
                setErrorMsgAlert(true)
              }
              response.json() 
            })
          .then(result => {})
          .catch(error => console.log('error', error)); 
      }
  

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Shoutouts" breadcrumbItem={breadCrumbText} />

          <Row>
            <Col className="col-12">
              <Card>
              <CardBody>
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form 
                        className=""
                        method="post"
                        id="tooltipForm">
                          <div>
                          <Row>
                              <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Name</Label>
                              <input
                                    className="form-control"
                                    defaultValue={ItemData?.item_name}
                                    disabled={true}
                                    type="text"
                                    id="name_input"
                                />
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                          </Row>  
                          <Row>
                              <Col lg={10} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Description</Label>
                              <input
                                    className="form-control"
                                    defaultValue={ItemData?.item_detail}
                                    type="text"
                                    id="description_input"
                                />
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                          </Row>                                              
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                  <CardBody>
                  <Row>
                              <Col lg={4} md={6} sm={6}>
                              <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                // isSearchable={true}
                                value={selectedStatus}
                                onChange={(e) => {
                                    setselectedStatus(e)
                                }}
                                placeholder={ItemData?.item_status == "Y" ? "Enabled" : selectedStatus ? selectedStatus.label : "Choose..."}
                                defaultValue={statusOptions.length > 0 && statusOptions[0]}
                                options={statusOptions}
                                required
                              />
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Version</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="version_input"
                                //   placeholder={ItemData?.item_version}
                                  defaultValue={18}
                              />
                              <small className="text-muted user-select-none">For mobile app only</small>
                            </div>
                            </div>
                            </Col>
                          </Row>
                  </CardBody>
              </Card>
              {success_msg ? (
                            renderSuccessAlert()
                          ) 
                          :
                          null 
                          }
                          {errorMsgAlert ? (
                            renderFailureAlert()
                          )
                          :
                          null
                          }
              <Row>
                  <Col></Col>
                  <Col>
                  <div className="d-print-none mt-4">
                        <div className="float-end" style={{marginBottom: 20}}>
                        {/* <Link to="#" className="btn btn-danger"> <FaRegTrashAlt /></Link>{" "} */}
                          <Link to="#" className="btn btn-danger" onClick={()=>{props?.history?.push("/estore-home/checkout")}}> <i className="uil uil-times me-1"></i> Cancel </Link>{" "}
                          <div onClick={()=>{
                              handleEdit()
                          }} className="btn btn-success w-md waves-effect waves-light">Save</div>
                        </div>
                </div>
                  </Col>
                  <Col lg={3}></Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditCheckout;
